import { render, staticRenderFns } from "./SampleProcessingTabSample.vue?vue&type=template&id=2a1e7b19&scoped=true&"
import script from "./SampleProcessingTabSample.vue?vue&type=script&lang=js&"
export * from "./SampleProcessingTabSample.vue?vue&type=script&lang=js&"
import style0 from "./SampleProcessingTabSample.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SampleProcessingTabSample.vue?vue&type=style&index=1&id=2a1e7b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e7b19",
  null
  
)

export default component.exports